var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h4',[_vm._v(_vm._s(_vm.$t('home.gpbUsd.title')))]),_c('p',{staticClass:"container-p"},[_vm._v(_vm._s(_vm.$t('home.gpbUsd.service')))]),_c('gpb-chart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }